module.exports = __webpack_public_path__ + "media/nicole2.38df7d5a.mp3";